import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { authActions } from 'features/auth'
import Form from './Form'

class LoginPage extends Component {
	handleSubmit = values => {
		const { login } = this.props
		const { email, password } = values

		login({
			email,
			password,
		})
	}

	render() {
		const {
			props: {
				location: { state },
			},
		} = this
		const { resendVerification } = this.props

		const loginMessage = state ? state?.loginMessage : null
		const loginMessageTitle = state ? state?.loginMessageTitle : null

		const awaitingVerification = !!(state && state.awaitingVerification)
		const awaitingVerificationEmail = awaitingVerification
			? state.awaitingVerificationEmail
			: null
		const resentVerification = !!(state && state.resentVerification)

		return (
			<Form
				onSubmit={this.handleSubmit}
				onResendVerification={resendVerification}
				resentVerification={resentVerification}
				loginMessage={{
					title: loginMessageTitle,
					description: loginMessage,
				}}
				awaitingVerification={awaitingVerification}
				awaitingVerificationEmail={awaitingVerificationEmail}
			/>
		)
	}
}

LoginPage.propTypes = {
	login: PropTypes.func.isRequired,
	resendVerification: PropTypes.func.isRequired,
}

const mapDispatchToProps = {
	login: authActions.loginRequest,
	resendVerification: authActions.resendVerificationRequest,
}

export default withRouter(connect(null, mapDispatchToProps)(LoginPage))
